module.exports = __webpack_public_path__ + "img/prox.75aa47b5.png";